// Form validation utilities

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  // UK phone number validation (basic)
  const phoneRegex = /^(\+44|0)[1-9]\d{8,9}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
};

export const validatePostcode = (postcode) => {
  // UK postcode validation (basic)
  const postcodeRegex = /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i;
  return postcodeRegex.test(postcode.replace(/\s/g, ''));
};

export const validateName = (name) => {
  return name.trim().length >= 2 && name.trim().length <= 100;
};

export const validateMessage = (message) => {
  return message.trim().length >= 10 && message.trim().length <= 1000;
};

export const validateContactForm = (formData) => {
  const errors = {};

  if (!validateName(formData.name)) {
    errors.name = 'Name must be between 2 and 100 characters';
  }

  if (!validateEmail(formData.email)) {
    errors.email = 'Please enter a valid email address';
  }

  if (formData.phone && !validatePhone(formData.phone)) {
    errors.phone = 'Please enter a valid UK phone number';
  }

  if (formData.postcode && !validatePostcode(formData.postcode)) {
    errors.postcode = 'Please enter a valid UK postcode';
  }

  if (!validateMessage(formData.message)) {
    errors.message = 'Message must be between 10 and 1000 characters';
  }

  return errors;
};

export const validateConsultationForm = (formData) => {
  const errors = {};

  if (!validateName(formData.name)) {
    errors.name = 'Name must be between 2 and 100 characters';
  }

  if (!validateEmail(formData.email)) {
    errors.email = 'Please enter a valid email address';
  }

  if (formData.phone && !validatePhone(formData.phone)) {
    errors.phone = 'Please enter a valid UK phone number';
  }

  if (formData.postcode && !validatePostcode(formData.postcode)) {
    errors.postcode = 'Please enter a valid UK postcode';
  }

  if (!validateMessage(formData.message)) {
    errors.message = 'Message must be between 10 and 1000 characters';
  }

  return errors;
};

export const validateNewsletterForm = (email) => {
  const errors = {};

  if (!validateEmail(email)) {
    errors.email = 'Please enter a valid email address';
  }

  return errors;
};

export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  
  return input
    .trim()
    .replace(/[<>]/g, '') // Remove potential HTML tags
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .replace(/on\w+=/gi, ''); // Remove event handlers
};

export const sanitizeFormData = (formData) => {
  const sanitized = {};
  
  for (const [key, value] of Object.entries(formData)) {
    if (typeof value === 'string') {
      sanitized[key] = sanitizeInput(value);
    } else {
      sanitized[key] = value;
    }
  }
  
  return sanitized;
};
